var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "calendar-view",
    attrs: { id: "popupAgenda", visible: _vm.showModal, size: "large" },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__header" },
              [
                _c("CompassIconButton", {
                  attrs: { icon: "close" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "div",
                { staticClass: "mt-2", attrs: { id: "content_agenda" } },
                [
                  _c("div", { attrs: { id: "third-fullcalendar" } }, [
                    _c("div", {
                      staticClass: "well",
                      attrs: {
                        id: "calendar",
                        relatedtype: _vm.relatedType,
                        relatedid: "" + _vm.relatedId + ""
                      }
                    })
                  ])
                ]
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }